import { useCallback, useContext } from 'react';

import { ExternalOfferFragment } from '@ocx/graphql';
import { LocalOffersLocationContext } from '@ocx/feat-local-offers';
import { ExternalBannerCard } from './components';
import { useLogOfferActivity } from '../../../../modules/external-loyalty';
import { useExternalBannerDetailsPopup } from '../../../../components/modals';

export type ExternalBannerCardControllerProps = {
  banner: ExternalOfferFragment;
  isAltriaOffersUnavailableNearby?: boolean;
};

export const ExternalBannerCardController = ({
  banner,
  isAltriaOffersUnavailableNearby,
}: ExternalBannerCardControllerProps) => {
  const { open: openExternalBannerDetailsPopup } = useExternalBannerDetailsPopup();
  const { logClick, logImpression } = useLogOfferActivity();

  const contextData = useContext(LocalOffersLocationContext);
  const locationState = contextData?.locationState ?? null;

  const shouldShowUnavailableWarning = isAltriaOffersUnavailableNearby && locationState !== 'all';

  const onBannerCardClick = useCallback(
    (trackingId: string) => {
      logClick(trackingId, banner.externalCampaignId, banner.bannerConfigurationUuid);
      openExternalBannerDetailsPopup({ banner, isAltriaOffersUnavailableNearby });
    },
    [banner, logClick, openExternalBannerDetailsPopup, isAltriaOffersUnavailableNearby],
  );

  const onImpression = useCallback(
    (offerId: string) => {
      logImpression(offerId, banner.externalCampaignId, banner.bannerConfigurationUuid);
    },
    [banner.bannerConfigurationUuid, banner.externalCampaignId, logImpression],
  );

  return (
    <ExternalBannerCard
      trackingId={banner.trackingId}
      content={banner.content}
      shouldShowUnavailableWarning={shouldShowUnavailableWarning}
      onImpression={onImpression}
      onClick={onBannerCardClick}
    />
  );
};
